(() => {
  if (!window.IntersectionObserver) {
    return;
  }

  const thresholdSteps = 100;
  const threshold = Array(thresholdSteps).fill('').map((entry, index) => index / thresholdSteps);
  const lastScaleValues = window.WeakMap ? new WeakMap() : new Map();
  const elems = new Set();
  let timer;

  const resetScale = (elem) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      elem.style.removeProperty('--swinger-navigation-scale');
    }, 100);
  };

  const setScale = (elem, scale) => {
    const lastScaleValue = lastScaleValues.get(elem) || 1;
    const newScaleValue = Math.max(0.7, Math.min(1, lastScaleValue * scale * (scale === 1 ? 1 : 0.98)));

    if (newScaleValue === lastScaleValue) {
      return;
    }

    elem.style.setProperty('--swinger-navigation-scale', `${newScaleValue}`);
    lastScaleValues.set(elem, scale);
  };

  const initResize = () => {
    if (!window.swinger.eventHub.register) {
      window.setTimeout(initResize, 100);
      return;
    }

    window.swinger.eventHub.register('resize', window, () => {
      elems.forEach((elem) => {
        lastScaleValues.set(elem, 1);
        resetScale(elem);
      });
    });
  };

  window.swinger.observer.initialize('.swinger-header__wrapper', (root) => {
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          return;
        }

        setScale(entry.target, entry.intersectionRatio);
      });
    }, {
      root,
      threshold,
    });

    window.swinger.observer.initialize('.swinger-header__wrapper .swinger-navigation__list--mainmenu', (elem) => {
      elems.add(elem);
      intersectionObserver.observe(elem);
    }, false);
  }, false);

  initResize();
})();
